import React, { Component } from "react";


class AdvanceTip extends Component {

    componentWillMount() {

    }


    render() {
        return (
            <div>
                {this.props.showOn ?
                    <div id="tipContainer">
                        <div id="tipBox" style={this.props.tipStyle} >
                            {this.props.closeBtnStyle ? <i onClick={this.props.cancelTip} className="fa fa-times" style={this.props.closeBtnStyle}></i> : null}
                            {this.props.pointerClass ? <div className={this.props.pointerClass ? this.props.pointerClass : "tDownLeft"} style={this.props.pointerStyle}></div> : null}
                            {this.props.pointerClass ? <div className={this.props.pointerClass ? this.props.pointerClass : "tDownLeft"} style={this.props.pointerStyle}></div> : null}
                            {this.props.children}
                        </div>
                    </div> : null}
            </div>

        );
    }
}

export default AdvanceTip;


// WEBPACK FOOTER //
// ./src/jsx/components/utility/advance-tip.jsx